'use strict';

var BaseInfoType = /*#__PURE__*/function (BaseInfoType) {
  BaseInfoType["Project"] = "project";
  BaseInfoType["Custom"] = "custom";
  BaseInfoType["Hidden"] = "hidden";
  BaseInfoType["FollowLight"] = "followLight";
  return BaseInfoType;
}({});
var NavBarAlign = /*#__PURE__*/function (NavBarAlign) {
  NavBarAlign["Left"] = "left";
  NavBarAlign["Center"] = "center";
  NavBarAlign["Right"] = "right";
  return NavBarAlign;
}({});
var LeftCatalogType = /*#__PURE__*/function (LeftCatalogType) {
  LeftCatalogType["NORMAL"] = "normal";
  LeftCatalogType["FOLD"] = "fold";
  return LeftCatalogType;
}({});
var NavTypeOptions = /*#__PURE__*/function (NavTypeOptions) {
  NavTypeOptions["PAGE"] = "page";
  NavTypeOptions["LINK"] = "link";
  NavTypeOptions["API_FOLDER"] = "folder";
  NavTypeOptions["REF_PROJECT"] = "project";
  NavTypeOptions["MULTIPLE_MENU"] = "menu";
  return NavTypeOptions;
}({});
var NavLinkTargetOptions = /*#__PURE__*/function (NavLinkTargetOptions) {
  NavLinkTargetOptions["SELF"] = "self";
  NavLinkTargetOptions["BLANK"] = "blank";
  return NavLinkTargetOptions;
}({});
var NavStyleOptions = /*#__PURE__*/function (NavStyleOptions) {
  NavStyleOptions["LEVEL_1"] = "level1";
  NavStyleOptions["LEVEL_2"] = "level2";
  NavStyleOptions["LEVEL_3"] = "level3";
  return NavStyleOptions;
}({});
var NavRightButtonStyleOptions = /*#__PURE__*/function (NavRightButtonStyleOptions) {
  NavRightButtonStyleOptions["RECTANGULAR_FILL"] = "rectangularFill";
  NavRightButtonStyleOptions["RADIUS_FILL"] = "radiusFill";
  NavRightButtonStyleOptions["RECTANGULAR_STROKE"] = "rectangularStroke";
  NavRightButtonStyleOptions["RADIUS_STROKE"] = "radiusStroke";
  NavRightButtonStyleOptions["SINGLE_TEXT"] = "singleText";
  return NavRightButtonStyleOptions;
}({});
var BannerBackgroundThemeOptions = /*#__PURE__*/function (BannerBackgroundThemeOptions) {
  BannerBackgroundThemeOptions["DARK"] = "dark";
  BannerBackgroundThemeOptions["LIGHT"] = "light";
  return BannerBackgroundThemeOptions;
}({});
var NavRightComponentType = /*#__PURE__*/function (NavRightComponentType) {
  NavRightComponentType["BUTTON"] = "button";
  NavRightComponentType["TEXT"] = "text";
  NavRightComponentType["ICON"] = "icon";
  return NavRightComponentType;
}({});
var TopBulletinComponentType = /*#__PURE__*/function (TopBulletinComponentType) {
  TopBulletinComponentType["TEXT"] = "text";
  return TopBulletinComponentType;
}({});
var FooterBannerComponentType = /*#__PURE__*/function (FooterBannerComponentType) {
  FooterBannerComponentType["IMAGE"] = "image";
  FooterBannerComponentType["BANNER"] = "banner";
  return FooterBannerComponentType;
}({});
var ApiDocLayout = /*#__PURE__*/function (ApiDocLayout) {
  ApiDocLayout["TwoColumn"] = "TwoColumn";
  ApiDocLayout["OneColumn"] = "OneColumn";
  return ApiDocLayout;
}({});
var CustomDomainMode = /*#__PURE__*/function (CustomDomainMode) {
  CustomDomainMode["CNAME"] = "CNAME";
  CustomDomainMode["REVERSE_PROXY"] = "REVERSE_PROXY";
  return CustomDomainMode;
}({});
var SSLCertificateType = /*#__PURE__*/function (SSLCertificateType) {
  SSLCertificateType["AUTO_GENERATE_CERTIFICATE"] = "AUTO_GENERATE_CERTIFICATE";
  SSLCertificateType["OWN_CERTIFICATE"] = "OWN_CERTIFICATE";
  return SSLCertificateType;
}({});
var SSLCertificateStatus = /*#__PURE__*/function (SSLCertificateStatus) {
  SSLCertificateStatus["EFFECTIVE"] = "EFFECTIVE";
  SSLCertificateStatus["EXPIRED"] = "EXPIRED";
  SSLCertificateStatus["CERT_ERROR"] = "CERT_ERROR";
  SSLCertificateStatus["PENDING"] = "PENDING";
  SSLCertificateStatus["CNAME_VERIFYING"] = "CNAME_VERIFYING";
  SSLCertificateStatus["CNAME_ERROR"] = "CNAME_ERROR";
  SSLCertificateStatus["DOMAIN_ERROR"] = "DOMAIN_ERROR";
  return SSLCertificateStatus;
}({});
var LandingPageType = /*#__PURE__*/function (LandingPageType) {
  LandingPageType["DEFAULT"] = "DEFAULT";
  LandingPageType["MARKDOWN"] = "MARKDOWN";
  LandingPageType["HTML"] = "HTML";
  return LandingPageType;
}({});
var ThemeMode = /*#__PURE__*/function (ThemeMode) {
  ThemeMode["LIGHT"] = "light";
  ThemeMode["DARK"] = "dark";
  ThemeMode["SYSTEM"] = "system";
  return ThemeMode;
}({});
var DocsSiteVisibilitySettingsType = /*#__PURE__*/function (DocsSiteVisibilitySettingsType) {
  DocsSiteVisibilitySettingsType["PUBLIC"] = "PUBLIC";
  DocsSiteVisibilitySettingsType["PASSWORD_PROTECTED"] = "PASSWORD_PROTECTED";
  DocsSiteVisibilitySettingsType["IP_WHITELIST"] = "IP_WHITELIST";
  DocsSiteVisibilitySettingsType["EMAIL_WHITELIST"] = "EMAIL_WHITELIST";
  DocsSiteVisibilitySettingsType["CUSTOM_AUTH"] = "CUSTOM_AUTH";
  return DocsSiteVisibilitySettingsType;
}({});
var EmailSettingsSubtitleType = /*#__PURE__*/function (EmailSettingsSubtitleType) {
  EmailSettingsSubtitleType["DEFAULT"] = "DEFAULT";
  EmailSettingsSubtitleType["CUSTOM"] = "CUSTOM";
  return EmailSettingsSubtitleType;
}({});
var EmailWhitelistMessageType = /*#__PURE__*/function (EmailWhitelistMessageType) {
  EmailWhitelistMessageType["DEFAULT"] = "DEFAULT";
  EmailWhitelistMessageType["CUSTOM"] = "CUSTOM";
  return EmailWhitelistMessageType;
}({});
var EmailTemplateType = /*#__PURE__*/function (EmailTemplateType) {
  EmailTemplateType["DEFAULT"] = "DEFAULT";
  EmailTemplateType["CUSTOM"] = "CUSTOM";
  return EmailTemplateType;
}({});
var SmtpServerType = /*#__PURE__*/function (SmtpServerType) {
  SmtpServerType["DEFAULT"] = "DEFAULT";
  SmtpServerType["CUSTOM"] = "CUSTOM";
  return SmtpServerType;
}({});
exports.ApiDocLayout = ApiDocLayout;
exports.BannerBackgroundThemeOptions = BannerBackgroundThemeOptions;
exports.BaseInfoType = BaseInfoType;
exports.CustomDomainMode = CustomDomainMode;
exports.DocsSiteVisibilitySettingsType = DocsSiteVisibilitySettingsType;
exports.EmailSettingsSubtitleType = EmailSettingsSubtitleType;
exports.EmailTemplateType = EmailTemplateType;
exports.EmailWhitelistMessageType = EmailWhitelistMessageType;
exports.FooterBannerComponentType = FooterBannerComponentType;
exports.LandingPageType = LandingPageType;
exports.LeftCatalogType = LeftCatalogType;
exports.NavBarAlign = NavBarAlign;
exports.NavLinkTargetOptions = NavLinkTargetOptions;
exports.NavRightButtonStyleOptions = NavRightButtonStyleOptions;
exports.NavRightComponentType = NavRightComponentType;
exports.NavStyleOptions = NavStyleOptions;
exports.NavTypeOptions = NavTypeOptions;
exports.SSLCertificateStatus = SSLCertificateStatus;
exports.SSLCertificateType = SSLCertificateType;
exports.SmtpServerType = SmtpServerType;
exports.ThemeMode = ThemeMode;
exports.TopBulletinComponentType = TopBulletinComponentType;
